import React, { useState } from 'react';
// import qrcode from '../images/qrcode.png';
import image1 from '../images/charity/amala-01.jpeg';
import image2 from '../images/charity/amala-02.jpeg';

const CharityPage = () => {
    const [selectedImage, setSelectedImage] = useState(null);

    return (
        <>
            <div className='container mx-auto'>
                <h1 className='text-xl lg:text-2xl font-bold text-gray-800 mt-6 mb-6 text-center'>Charity Services</h1>
                <div className="mb-6 px-6">
                    <strong>Financial support provided to Ms.Amala for Treatment</strong>
                    <p><em>August, 2026</em></p>
                </div>
                <div className="px-6">
                    <p className="mb-6">Rama Dharma Prachara Sabha provided financial assistance to Ms. Amala aged 32 years
                        for her treatment of Dengue fever, admitted at Durgabhai Deshmukh Hospital and Research Centre, 
                        Vidyanagar, Hyderabad. Request needful help and support from all.
                    </p>
                    {/* --- Responsive Image Thumbnails Grid --- */}
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-6">
                        <div 
                            className="cursor-pointer overflow-hidden rounded-lg border border-gray-200 shadow-sm hover:shadow-md transition-shadow"
                            onClick={() => setSelectedImage(image1)}
                        >
                            <img 
                                src={image1} 
                                alt="Charity" 
                                className="w-full h-48 object-cover hover:scale-105 transition-transform duration-300"
                            />
                        </div>

                        <div 
                            className="cursor-pointer overflow-hidden rounded-lg border border-gray-200 shadow-sm hover:shadow-md transition-shadow"
                            onClick={() => setSelectedImage(image2)}
                        >
                            <img 
                                src={image2} 
                                alt="Charity" 
                                className="w-full h-48 object-cover hover:scale-105 transition-transform duration-300"
                            />
                        </div>
                    </div>
                    {/* ------------------------------------- */}   
                    <p className="mb-6">Jai Sri Ram<br />Anilkumar E S<br />Secretary<br />Rama Dharma Prachara Sabha</p>
                </div>
            </div>
            {/* --- Modal / Lightbox for Enlarged View --- */}
            {selectedImage && (
                <div 
                    className="fixed inset-0 bg-black bg-opacity-75 z-50 flex items-center justify-center p-4 transition-opacity"
                    onClick={() => setSelectedImage(null)} // Click anywhere backdrop to close
                >
                    <div className="relative max-w-3xl max-h-[90vh] p-2 bg-white rounded-lg shadow-2xl">
                        {/* Close button */}
                        <button 
                            className="absolute -top-3 -right-3 bg-red-600 text-white rounded-full w-8 h-8 flex items-center justify-center font-bold hover:bg-red-700 shadow-lg"
                            onClick={() => setSelectedImage(null)}
                        >
                            ✕
                        </button>
                        
                        {/* Full Size Image */}
                        <img 
                            src={selectedImage} 
                            alt="Enlarged view" 
                            className="max-w-full max-h-[80vh] object-contain rounded"
                        />
                    </div>
                </div>
            )}
        </>
    );
};

export default CharityPage;